import { useLocation } from 'react-router-dom';

// Views of a page, shown as sub-items in the sidebar (desktop) and as chips (mobile).
// The first view lives at the page's own URL.
export const subViews = {
  '/kamiony': [
    { key: 'today', path: '/kamiony', label: 'arrivals.tabToday' },
    { key: 'actions', path: '/kamiony/akce', label: 'actions.title' },
    { key: 'map', path: '/kamiony/mapa', label: 'trucks.siteMap' },
    { key: 'import', path: '/kamiony/import', label: 'import.title' },
    { key: 'sources', path: '/kamiony/zdroje', label: 'sources.title' },
  ],
  '/statistiky': [
    { key: 'overview', path: '/statistiky', label: 'stats.tab.overview' },
    { key: 'carriers', path: '/statistiky/dopravci', label: 'stats.tab.carriers' },
    { key: 'urgency', path: '/statistiky/urgence', label: 'stats.tab.urgency' },
    { key: 'site', path: '/statistiky/areal', label: 'stats.tab.site' },
    { key: 'reports', path: '/statistiky/reporty', label: 'stats.tab.reports' },
  ],
};

export const isInSection = (pathname, base) => pathname === base || pathname.startsWith(`${base}/`);

// Base path of the page with views the URL belongs to, or null.
export const sectionOf = (pathname) => Object.keys(subViews).find(base => isInSection(pathname, base)) || null;

// Current view of `base`; unknown sub-paths fall back to the first view.
export const currentView = (pathname, base) => {
  const views = subViews[base];
  return views.find(v => v.path === pathname) || views[0];
};

// Key of the current view of the page at `base`.
export function useSubView(base) {
  const { pathname } = useLocation();
  return currentView(pathname, base).key;
}
